import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import { apiSlice } from './slices/apiSlice';
import { userApiSlice } from './slices/usersApiSlice';
import { emailApiSlice } from './slices/emailApiSlice';
import { itemApi } from './slices/itemApiSlice';

const store = configureStore({
  reducer: {
    auth: authSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [userApiSlice.reducerPath]: userApiSlice.reducer,
    [emailApiSlice.reducerPath]: emailApiSlice.reducer,
    [itemApi.reducerPath]: itemApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
      userApiSlice.middleware,
      emailApiSlice.middleware,
      itemApi.middleware
    ),
  devTools: true,
});

export default store;
